import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust according to your Firebase setup
import './styles/ManageStatDom.css';
import NavbarAdmin from '../components/NavbarAdmin';

const ManageStatDom = () => {
  const [statistics, setStatistics] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    AgricultureMontant: 0,
    AgricultureNombre: 0,
    IndustrieMontant: 0,
    IndustrieNombre: 0,
    CommerceMontant: 0,
    CommerceNombre: 0,
    ServicesMontant: 0,
    ServicesNombre: 0,
    ArtisanatMontant: 0,
    ArtisanatNombre: 0,
    Amelioration_des_conditions_de_vieMontant: 0,
    Amelioration_des_conditions_de_vieNombre: 0,
    Cultures_maraicheresMontant: 0,
    Cultures_maraicheresNombre: 0,
    Grandes_culturesMontant: 0,
    Grandes_culturesNombre: 0,
    annee: ''
  });
  const [years, setYears] = useState([]);
  const [selectedStat, setSelectedStat] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'statistics_domaine'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStatistics(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchStatistics();
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear + 5;
    const yearsArray = [];
    for (let year = startYear; year <= endYear; year++) {
      yearsArray.push(year);
    }
    setYears(yearsArray);
  }, []);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    const newValue = name.includes('Montant') || name.includes('Nombre') ? parseFloat(value) || 0 : value;
    setEditData({ ...editData, [name]: newValue });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, 'statistics_domaine', editId);
      await updateDoc(docRef, {
        ...editData,
        AgricultureMontant: parseFloat(editData.AgricultureMontant) || 0,
        AgricultureNombre: parseFloat(editData.AgricultureNombre) || 0,
        IndustrieMontant: parseFloat(editData.IndustrieMontant) || 0,
        IndustrieNombre: parseFloat(editData.IndustrieNombre) || 0,
        CommerceMontant: parseFloat(editData.CommerceMontant) || 0,
        CommerceNombre: parseFloat(editData.CommerceNombre) || 0,
        ServicesMontant: parseFloat(editData.ServicesMontant) || 0,
        ServicesNombre: parseFloat(editData.ServicesNombre) || 0,
        ArtisanatMontant: parseFloat(editData.ArtisanatMontant) || 0,
        ArtisanatNombre: parseFloat(editData.ArtisanatNombre) || 0,
        Amelioration_des_conditions_de_vieMontant: parseFloat(editData.Amelioration_des_conditions_de_vieMontant) || 0,
        Amelioration_des_conditions_de_vieNombre: parseFloat(editData.Amelioration_des_conditions_de_vieNombre) || 0,
        Cultures_maraicheresMontant: parseFloat(editData.Cultures_maraicheresMontant) || 0,
        Cultures_maraicheresNombre: parseFloat(editData.Cultures_maraicheresNombre) || 0,
        Grandes_culturesMontant: parseFloat(editData.Grandes_culturesMontant) || 0,
        Grandes_culturesNombre: parseFloat(editData.Grandes_culturesNombre) || 0
      });
      alert("Document updated successfully!");
      setEditId(null);
      setEditData({
        AgricultureMontant: 0,
        AgricultureNombre: 0,
        IndustrieMontant: 0,
        IndustrieNombre: 0,
        CommerceMontant: 0,
        CommerceNombre: 0,
        ServicesMontant: 0,
        ServicesNombre: 0,
        ArtisanatMontant: 0,
        ArtisanatNombre: 0,
        Amelioration_des_conditions_de_vieMontant: 0,
        Amelioration_des_conditions_de_vieNombre: 0,
        Cultures_maraicheresMontant: 0,
        Cultures_maraicheresNombre: 0,
        Grandes_culturesMontant: 0,
        Grandes_culturesNombre: 0,
        annee: ''
      });
      // Refetch data to update the table
      const querySnapshot = await getDocs(collection(db, 'statistics_domaine'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setStatistics(data);
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet élément ?")) {
      try {
        await deleteDoc(doc(db, 'statistics_domaine', id));
        alert("Document deleted successfully!");
        // Refetch data to update the table
        const querySnapshot = await getDocs(collection(db, 'statistics_domaine'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStatistics(data);
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };

  const handleShowDetails = (stat) => {
    setSelectedStat(stat);
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };const headingStyle = {
    fontSize: '2rem',
    color: '#cc6699',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px'
  };

  const formStyle = {
    background: '#f9f9f9',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    margin: 'auto'
  };

  const headingFormStyle = {
    color: '#66b3ff',
    marginBottom: '20px',
    fontSize: '1.5rem',
    textAlign: 'center'
  };

  const formGroupStyle = {
    marginBottom: '20px'
  };

  const sectionTitleStyle = {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333'
  };

  const labelStyle = {
    display: 'block',
    fontWeight: 'normal',
    marginBottom: '5px'
  };

  const inputStyle = {
    width: 'calc(50% - 16px)',
    padding: '8px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '0.875rem',
    display: 'inline-block'
  };

  const selectStyle = {
    marginLeft: '10px'
  };

  const buttonStyle = {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    cursor: 'pointer',
    borderRadius: '4px',
    fontSize: '0.875rem',
    display: 'block',
    width: '100%',
    marginTop: '20px'
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3'
  };

  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
        <h2 style={headingStyle}>Gérer les Statistiques par Secteur</h2>
        <table>
          <thead>
            <tr>
              <th><center>Année</center></th>
              <th><center>Actions</center></th>
            </tr>
          </thead>
          <tbody>
            {statistics.map(stat => (
              <tr key={stat.id}>
                <td className="annee">{stat.annee}</td>
                <td>
                  <button className="afficher" onClick={() => handleShowDetails(stat)}>Afficher</button>&nbsp;&nbsp;
                  <button className="modifier" onClick={() => {
                    setEditId(stat.id);
                    setEditData({
                      AgricultureMontant: stat.AgricultureMontant,
                      AgricultureNombre: stat.AgricultureNombre,
                      IndustrieMontant: stat.IndustrieMontant,
                      IndustrieNombre: stat.IndustrieNombre,
                      CommerceMontant: stat.CommerceMontant,
                      CommerceNombre: stat.CommerceNombre,
                      ServicesMontant: stat.ServicesMontant,
                      ServicesNombre: stat.ServicesNombre,
                      ArtisanatMontant: stat.ArtisanatMontant,
                      ArtisanatNombre: stat.ArtisanatNombre,
                      Amelioration_des_conditions_de_vieMontant: stat.Amelioration_des_conditions_de_vieMontant,
                      Amelioration_des_conditions_de_vieNombre: stat.Amelioration_des_conditions_de_vieNombre,
                      Cultures_maraicheresMontant: stat.Cultures_maraicheresMontant,
                      Cultures_maraicheresNombre: stat.Cultures_maraicheresNombre,
                      Grandes_culturesMontant: stat.Grandes_culturesMontant,
                      Grandes_culturesNombre: stat.Grandes_culturesNombre,
                      annee: stat.annee
                    });
                  }}>Modifier</button>&nbsp;&nbsp;
                  <button className="supprimer" onClick={() => handleDelete(stat.id)}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {editId && (
          <form onSubmit={handleEditSubmit} style={formStyle}>
            <h3 style={headingFormStyle}>Modifier les Statistiques par Secteur</h3>
            {['Agriculture', 'Industrie', 'Commerce', 'Services', 'Artisanat', 'Amélioration des Conditions de Vie', 'Cultures Maraîchères', 'Grandes Cultures'].map((section, index) => (
              <div key={index} style={formGroupStyle}>
                <div style={sectionTitleStyle}>{section}</div>
                <label style={labelStyle}>
                  Montant:
                  <input
                    type="number"
                    name={`${section}Montant`}
                    value={editData[`${section}Montant`] || ''}
                    onChange={handleEditChange}
                    step="0.01"
                    style={inputStyle}
                    required
                  />
                </label>
                <label style={labelStyle}>
                  Nombre de personnes:
                  <input
                    type="number"
                    name={`${section}Nombre`}
                    value={editData[`${section}Nombre`] || ''}
                    onChange={handleEditChange}
                    step="1"
                    style={inputStyle}
                    required
                  />
                </label>
              </div>
            ))}

            <div style={formGroupStyle}>
              <label style={labelStyle}>
                Année:
                <select
                  name="annee"
                  value={editData.annee}
                  onChange={handleEditChange}
                  required
                  style={selectStyle}
                >
                  <option value="" disabled>Choisissez une année</option>
                  {years.map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </label>
            </div>
            <button type="submit" style={buttonStyle} onMouseOver={(e) => e.currentTarget.style.backgroundColor = buttonHoverStyle.backgroundColor} onMouseOut={(e) => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}>Mettre à jour</button>
          </form>
        )}

        {showDetails && selectedStat && (
          <div className="details-modal">
            <button className="close-btn" onClick={handleCloseDetails}>Fermer</button>
            <h3>Détails pour l'année {selectedStat.annee}</h3>
            <p><strong>Agriculture:</strong> Montant: {selectedStat.AgricultureMontant}, Nombre de personnes: {selectedStat.AgricultureNombre}</p>
            <p><strong>Industrie:</strong> Montant: {selectedStat.IndustrieMontant}, Nombre de personnes: {selectedStat.IndustrieNombre}</p>
            <p><strong>Commerce:</strong> Montant: {selectedStat.CommerceMontant}, Nombre de personnes: {selectedStat.CommerceNombre}</p>
            <p><strong>Services:</strong> Montant: {selectedStat.ServicesMontant}, Nombre de personnes: {selectedStat.ServicesNombre}</p>
            <p><strong>Artisanat:</strong> Montant: {selectedStat.ArtisanatMontant}, Nombre de personnes: {selectedStat.ArtisanatNombre}</p>
            <p><strong>Amélioration des conditions de vie:</strong> Montant: {selectedStat.Amelioration_des_conditions_de_vieMontant}, Nombre de personnes: {selectedStat.Amelioration_des_conditions_de_vieNombre}</p>
            <p><strong>Cultures maraîchères:</strong> Montant: {selectedStat.Cultures_maraicheresMontant}, Nombre de personnes: {selectedStat.Cultures_maraicheresNombre}</p>
            <p><strong>Grandes cultures:</strong> Montant: {selectedStat.Grandes_culturesMontant}, Nombre de personnes: {selectedStat.Grandes_culturesNombre}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageStatDom;